import React, { useState, useEffect } from "react";
import { FormControl, Select, MenuItem, styled } from "@mui/material";
import secureLocalStorage from "react-secure-storage";
import { useTranslation } from "react-i18next";

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  backgroundColor: 'var(--button-alternative-default, #303034)',
  color: 'var(--font-mine)',
  fontFamily: "'Inter', sans-serif",
  fontSize: '14px',
  '&:hover': {
    backgroundColor: 'var(--buttons-alternative-hover, #303034)',
  },
  '&.Mui-selected': {
    backgroundColor: 'var(--button-alternative-default, #303034) !important',
    '&:hover': {
      backgroundColor: 'var(--buttons-alternative-hover, #303034)',
    },
  },
}));
export default function LanguageButton() {
  const { t, i18n } = useTranslation();
  const [lang, setLang] = useState(secureLocalStorage.getItem("lang") || "en");

  useEffect(() => {
    changeLanguage(lang);
  }, [lang]);

  const handleChange = (event) => {
    const newLang = event.target.value;
    setLang(newLang);
    changeLanguage(newLang);
  };

  function changeLanguage(e) {
    i18n.changeLanguage(e);
    secureLocalStorage.setItem("lang", e);
  }

  const languages = ["en", "de", "pl", "fr", "it", "cz", "es"];

  return (
    <FormControl
      sx={{  minWidth: 50 }}
    >
      <Select
        value={lang}
        onChange={handleChange}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        sx={{color:'var(--font-mine)',fontFamily:"'Inter',sans-serif",fontSize:'14px',background:'var(--button-alternative-default, #303034)',border:"1px solid var(--border-button, rgba(255, 255, 255, 0.08))",
          "& .MuiSelect-select":{padding:"0.3vh !important",paddingRight:"1.5vh !important"},
          "& .MuiSvgIcon-root":{fill:'var(--font-mine)',right:'-1px'}
        }}
        MenuProps={{
          MenuListProps: {
            sx: {
              '& .MuiMenuItem-root': {
                backgroundColor: 'var(--button-alternative-default, #303034)',
                color: 'var(--font-mine)',
                fontFamily: "'Inter', sans-serif",
                fontSize: '14px',
                '&.Mui-selected': {
                  backgroundColor: 'var(--button-alternative-default, #303034) !important',
                },
              },
            },
          },
        }}
      >
        {languages.map((el) => (
                  <CustomMenuItem value={el} key={el}
                    sx={{background:'var(--button-alternative-default, #303034)',
                      color:'var(--font-mine)',
                      fontFamily:"'Inter',sans-serif",fontSize:'14px',
                      "& .Mui-selected":{
                        background:'var(--button-alternative-default, #303034) !important',
                      }
                    }}
                  >{el.toUpperCase()}</CustomMenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
